import React from "react";
import { Link } from "react-router-dom";
import carpet from "../assets/images/carpet.png";

import StarPurple500OutlinedIcon from "@mui/icons-material/StarPurple500Outlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";

export default function ProductCard({ product }) {
  return (
    <div className="product_card">
      <div className="product_img">
        <Link to={`/product/${product.id}`}>
          <img src={product.image} alt={product.name} className="img1" />
          <img src={carpet} alt="" className="img2" />
        </Link>
        <div className="wishlist_icon">
          <a href="#">
            <FavoriteBorderOutlinedIcon />
          </a>
        </div>
      </div>
      <div className="product_details">
        <Link to={`/product/${product.id}`}>
          <h3>{product.name}</h3>
        </Link>

        <div className="stars">
          <StarPurple500OutlinedIcon />
          <StarPurple500OutlinedIcon />
          <StarPurple500OutlinedIcon />
          <StarPurple500OutlinedIcon />
          <StarPurple500OutlinedIcon />
        </div>

        <p className="size">{product.size}</p>
        <div className="product_price">
          <del>₹ {product.oldPrice}</del>
          <p className="main_price">₹ {product.price}</p>
        </div>
      </div>
    </div>
  );
}
